import React, { useEffect, useRef } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { KeyDetailsStrip } from '../components/KeyDetailsStrip';
import { KeyHighlights } from '../components/KeyHighlights';
import { WhyCremorne } from '../components/WhyCremorne';
import { GallerySection } from '../components/GallerySection';
import { AgentSection } from '../components/AgentSection';
import { Footer } from '../components/Footer';
import { initGA4, trackScrollDepth } from '../utils/analytics';
export function PropertyPage() {
  const scrollFired = useRef({
    half: false,
    full: false
  });
  useEffect(() => {
    initGA4();
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const percent = scrollTop / docHeight * 100;
      if (percent >= 50 && !scrollFired.current.half) {
        scrollFired.current.half = true;
        trackScrollDepth(50);
      }
      if (percent >= 98 && !scrollFired.current.full) {
        scrollFired.current.full = true;
        trackScrollDepth(100);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-brand-black selection:bg-brand-gold selection:text-brand-black" data-id="element-88">
      <Navbar data-id="element-89" />
      <main data-id="element-90">
        <HeroSection data-id="element-91" />
        <KeyDetailsStrip data-id="element-92" />
        <KeyHighlights data-id="element-93" />
        <WhyCremorne data-id="element-94" />
        <GallerySection data-id="element-95" />
        <AgentSection data-id="element-96" />
      </main>
      <Footer data-id="element-97" />
    </div>;
}